import getSourceDataById from "@app/services/cases/getSourceDataById";
import getEmailsBySourceDataId from "@app/services/cases/getEmailsBySourceDataId";

export const fetchSourceData = async data_source_id => {
  const {
    data: [sourceData],
  } = await getSourceDataById(data_source_id);

  return sourceData;
};

export const fetchAttachments = async data_source_id => {
  const { data = [] } = await getEmailsBySourceDataId(data_source_id);

  const attachments = data.flatMap(({ attachments }) => attachments);

  return attachments;
};
